import React, { useEffect, useState } from 'react';
import './GridSection.css';
import Carousel from './Carousel'; // Import the new component

const services = [
  { image: '/images/services_01_lights.png', name: 'Lights', icon: '/icons/pendent-light.png' },
  { image: '/images/services_02_receptacle.png', name: 'Receptacle', icon: '/icons/receptacle-01.png' },
  { image: '/images/services_03_security-camera.png', name: 'Security Camera', icon: '/icons/security-camera-01.png' },
  { image: '/images/services_04_renovation.png', name: 'Renovation', icon: '/icons/renovation.png' },
  { image: '/images/services_05_electric-panel.png', name: 'Electric Panel', icon: '/icons/electric-panel-01.png' },
  { image: '/images/services_06_ev-charger.png', name: 'EV Charger', icon: '/icons/ev-charger.png' },
  { image: '/images/services_07_lanscape-lighting.png', name: 'Landscape Lighting', icon: '/icons/landscape-lighting.png' },
  { image: '/images/services_08_ceiling-fan.png', name: 'Ceiling Fan', icon: '/icons/ceiling-fan.png' },
  { image: '/images/services_09_smoke-detectors.png', name: 'Smoke Detectors', icon: '/icons/smoke-detector.png' },
  { image: '/images/services_10_surge-protection.png', name: 'Surge Protection', icon: '/icons/surge-protector.png' },
  { image: '/images/services_11_generator-hook-up.png', name: 'Generator Hook-Up', icon: '/icons/generator.png' },
  { image: '/images/services_12_hot-tub-hook-up.png', name: 'Hot Tub Hook-Up', icon: '/icons/hot-tub.png' }
];

const GridSection = React.forwardRef((props, ref) => {
  // Determine mobile to adjust animation phasing per viewport
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 480px)');
    const apply = () => setIsMobile(mq.matches);
    apply();
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', apply) : mq.removeListener(apply);
    };
  }, []);

  const topDelay = '0s';
  const middleDelay = isMobile ? '-26.7s' : '0s'; // Desktop: start at end naturally (left starts at -50%)
  const thirdDelay = isMobile ? '-53.4s' : '0s';

  // On mobile, rotate starting items so rows show different images initially
  const topStart = isMobile ? 0 : 0;
  const middleStart = isMobile ? 4 : 0; // shift by 4 items (12 total)
  const thirdStart = isMobile ? 8 : 0;  // shift by 8 items

  return (
    <div className="grid-section" ref={ref}>
      <h2 className="grid-section-header">Our Services</h2>
      <Carousel services={services} direction="right" delay={topDelay} startIndex={topStart} />
      {/* Desktop: left track starts at end; Mobile: offset further */}
      <Carousel services={services} direction="left" delay={middleDelay} startIndex={middleStart} />
      <div className="mobile-only" style={{ width: '100%' }}>
        {/* Evenly stagger the third row on mobile */}
        <Carousel services={services} direction="right" delay={thirdDelay} startIndex={thirdStart} />
      </div>
    </div>
  );
});

export default GridSection;
